// extracted by mini-css-extract-plugin
export default {"header":"styles_header__0Y0uW","headerButtons":"styles_headerButtons__Etk+y","button":"styles_button__chNfy"};